import PropTypes from "prop-types";

/**
 * PropTypes for Transactions view
 *
 * @property {Array<Object>} [transactions] - Array of transaction data
 * @property {Array<TableHeader>} [headers] - Table column headers
 * @property {boolean} [loading] - Loading state
 * @property {Object} [filters] - Active filter values
 * @property {function} [onFilterChange] - Filter change handler
 */
export const transactionsPropTypes = {
  transactions: PropTypes.arrayOf(PropTypes.object),
  headers: PropTypes.array,
  loading: PropTypes.bool,
  filters: PropTypes.object,
  onFilterChange: PropTypes.func,
};

